/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

//require('dotenv').config({ path: '.env.dev' });

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL Node configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-node/docs/configuration.md
 */

export const msalConfig = {
    auth: {
        clientId: process.env.MS_AD_CLIENT_ID, // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
        authority: process.env.MS_AD_AUTH_URL, // Full directory URL, in the form of https://login.microsoftonline.com/<tenant>
        redirectUri: process.env.REDIRECT_URI, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: process.env.POST_LOGOUT_REDIRECT_URI, // Indicates the page to navigate after logout.
        scopes: ['user.read'],
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Avoid stale cookie interaction state; rely on sessionStorage cache.
    },
    system: {
        loggerOptions: {
            loggerCallback() { },
            piiLoggingEnabled: false,
            logLevel: 3,
        }
    }
}
